import { defineStore } from "pinia";
import { ref } from "vue";
import { useAxios } from "@/composables/api.js";
import { catchError } from "@/composables/error.js";
import { Participant } from "@/types/participant";

export const useAssessmentStore = defineStore("assessment", () => {
  const assessments: Ref<Participant[]> = ref([]);

  const results = ref(null);

  const documents = ref([]);

  async function getCandidateAssessments() {
    try {
      const { data } = await useAxios.get("/candidates/me/assessments");

      assessments.value = data.assessments;
      results.value = data.results;
      documents.value = data.documents;

      return data;
    } catch (error) {
      return catchError(error);
    }
  }

  function clear() {
    assessments.value = [];
    results.value = [];
  }

  return {
    assessments,
    results,
    documents,
    clear,
    getCandidateAssessments,
  };
});
